import { Link } from "react-router-dom";
import { ArrowUpRight } from "lucide-react";
import { NAV_KEYS, useLang } from "@/i18n";

export const Teasers = () => {
  const { t, to } = useLang();
  return (
    <section data-testid="home-teasers" className="bg-[#EAE5D9]/60 border-y border-[#D3CEC4]/60">
      <div className="max-w-7xl mx-auto px-6 sm:px-12 py-20 sm:py-28">
        <p className="text-[11px] tracking-[0.32em] uppercase font-semibold text-[#374F49]">{t.home.teasersOverline}</p>
        <h2 className="font-serif font-medium mt-4 text-4xl sm:text-5xl leading-tight text-[#1A2522]">{t.home.teasersTitle}</h2>
        <div className="mt-14 grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-6">
          {NAV_KEYS.map((k, i) => (
            <Link
              key={k}
              to={to(k)}
              data-testid={`teaser-${k}`}
              className="card-lift group bg-[#F8F6F0] border border-[#D3CEC4] rounded-2xl p-8 flex flex-col reveal"
              style={{ animationDelay: `${i * 0.06}s` }}
            >
              <span className="font-serif text-sm text-[#7A857F]">0{i + 1}</span>
              <h3 className="font-serif text-2xl sm:text-[24.5px] mt-4 text-[#1A2522]">{t.nav[k]}</h3>
              <p className="mt-3 text-[13px] text-[#495854] leading-relaxed flex-1">{t.home.teasers[k]}</p>
              <span className="mt-8 inline-flex items-center gap-2 text-[12px] tracking-[0.2em] uppercase font-semibold text-[#374F49] group-hover:text-[#1A2522] transition-colors">
                {t.home.teasersGo} <ArrowUpRight className="w-4 h-4 transition-transform group-hover:translate-x-0.5 group-hover:-translate-y-0.5" />
              </span>
            </Link>
          ))}
        </div>
      </div>
    </section>
  );
};
